<template>
  <CursorBase v-if="cursorType !== 'DEFAULT' && !isMobileViewport">
    <CursorCircle  v-if="cursorType === 'CIRCLE'" />
    <CursorArrow   v-else-if="cursorType === 'ARROW'" />
    <CursorLabeled v-else-if="cursorType === 'LABELED'" />
    <CursorBlurred v-else-if="cursorType === 'BLURRED'" />
    <CursorFigma   v-else-if="cursorType === 'FIGMA'" />
    <CursorEmoji   v-else-if="cursorType === 'EMOJI'" />
  </CursorBase>
</template>

<script>
export default { name: 'Cursor' };
</script>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { isPortfolioGenerationPreviewRoute } from '@/scripts/view/portfolio/generationPreview.js';
import CursorBase    from './cursors/CursorBase.vue';
import CursorCircle  from './cursors/CursorCircle.vue';
import CursorArrow   from './cursors/CursorArrow.vue';
import CursorLabeled from './cursors/CursorLabeled.vue';
import CursorBlurred from './cursors/CursorBlurred.vue';
import CursorFigma   from './cursors/CursorFigma.vue';
import CursorEmoji   from './cursors/CursorEmoji.vue';

const store = useStore();
const route = useRoute();

// The AI generator shows the portfolio in a preview that has a cursor of its own, with
// a note on it; a template's cursor under that one would be two cursors at once.
const cursorType = computed(() => {
  if (isPortfolioGenerationPreviewRoute(route)) return 'DEFAULT';
  return store.state.portfolio?.templateSettings?.cursorType || 'DEFAULT';
});

const isMobileViewport = ref(false);

function checkViewport() {
  if (typeof window === 'undefined') return;
  const width = window.innerWidth;
  const ua = navigator.userAgent || '';
  
  // Standard user agent checks for mobile/tablet
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  
  // iPadOS 13+ detection (which reports as Macintosh but is touch-based)
  const isIPadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(ua);
  
  // Check if viewport width is less than 1024px (standard tablet and mobile viewport threshold)
  const isSmallScreen = width < 1024;
  
  isMobileViewport.value = !!(isMobileUA || isIPadOS || isSmallScreen);
}

onMounted(() => {
  checkViewport();
  window.addEventListener('resize', checkViewport);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkViewport);
});
</script>
